import { render, staticRenderFns } from "./GKChips.vue?vue&type=template&id=94d41f6e&scoped=true&"
import script from "./GKChips.vue?vue&type=script&lang=js&"
export * from "./GKChips.vue?vue&type=script&lang=js&"
import style0 from "./GKChips.vue?vue&type=style&index=0&id=94d41f6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d41f6e",
  null
  
)

export default component.exports